/* eslint consistent-return:0 */
import { info } from '../../jsCore/application/console'
import { parentElementUntil } from '../../jsCore/utils/dom'
import { queryString as qs } from '../../jsCore/utils/window'
import { dispatch } from '../../jsCore/application/appStore'
import analyticsActions from '../../jsCore/organizedByType/actions/analyticsActions'

const FEATURE_FLAGS = {
  debug: qs.debugAnalyticsClickHandler,
}

const hasAnalyticsClickEventCategoryAttribute = target =>
  target && target.hasAttribute('data-analytics-event-category')

const isAnchor = el => el instanceof HTMLAnchorElement

const isButton = el => el instanceof HTMLButtonElement

const isAnalyticsElement = el =>
  (isAnchor(el) || isButton(el)) && hasAnalyticsClickEventCategoryAttribute(el)

const parentUntilCategoryAttribute = parentElementUntil(hasAnalyticsClickEventCategoryAttribute)

const parentUntilClickable = parentElementUntil(isAnalyticsElement)

function debug() {
  FEATURE_FLAGS.debug && info('[analytics click handler]', ...arguments)
}

function lowerCaseIfString(value) {
  return typeof value === 'string' ? value.toLowerCase() : value
}

function normalizeEventData(eventMetadata) {
  return Object.entries(eventMetadata).reduce((acc, [key, value], idx) => {
    if (idx === 0) {
      return { ...acc, [key]: value }
    }
    return value === undefined ? acc : { ...acc, [key]: lowerCaseIfString(value) }
  }, {})
}

function addGtmAnchorCallback(evt) {
  const maybeClickable = parentUntilClickable(evt.target)
  if (!maybeClickable || !maybeClickable.target || maybeClickable.target.length > 0) {
    return
  }

  evt.preventDefault()
  return {
    eventCallback() {
      window.location = maybeClickable.href
    },
    eventTimeout: 1000,
  }
}

function delegatedAnalyticsClickHandler(evt) {
  const gtmAnchorCallback = addGtmAnchorCallback(evt)
  const target = evt.target
  debug('target', target)
  const targetDataValue = target.dataset.analyticsEventValue
  const analyticsElementOrNull = parentUntilCategoryAttribute(target)
  if (!analyticsElementOrNull) {
    return
  }
  const {
    analyticsEventCategory: eventCategory,
    analyticsEventAction: eventAction,
    analyticsEventLabel: eventLabel,
    analyticsEventValue: eventValue,
  } = analyticsElementOrNull.dataset
  if (eventCategory && eventAction) {
    dispatch(
      analyticsActions.pageClicked(
        normalizeEventData({
          eventCategory,
          eventAction,
          eventLabel,
          eventValue: eventValue || targetDataValue,
          gtmAnchorCallback,
        })
      )
    )
  }
}

export default function addAnalyticsClickDelegator() {
  document.body.addEventListener('click', delegatedAnalyticsClickHandler)
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/track_analytics_click_events/trackAnalyticsClickEvents.js